// extracted by mini-css-extract-plugin
export default {"desktop-view":"LandscapeView_desktop-view__yzuo5","mobile-view":"LandscapeView_mobile-view__7Wvba"};